"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var PortfolioConfigModel = /** @class */ (function () {
    function PortfolioConfigModel(categorySystemName, pageSize, columns, deFormName, formId, defaultFilter, enableWorkflowBulkActions, workflowBulkActionIds, enableWfActions, bulkActionsLimit, defaultSortingField, sortingDirection, itemsNumbersPerPage, moneyColumnByCurrency, categoryPermissions, additionalFieldsToLoad, categoryFieldsToLoad) {
        this._formId = 0;
        this._bulkActionsLimit = 150;
        this._enableWfActions = false;
        /**
             * enable workflow bulk actions
             * @type {boolean}
             */
        this._enableWorkflowBulkActions = false;
        this._categoryPermissions = categoryPermissions;
        this._categorySystemName = categorySystemName;
        this._columns = columns;
        this._deFormName = deFormName;
        this._formId = formId;
        this._defaultFilter = defaultFilter;
        this._itemsNumbersPerPage = itemsNumbersPerPage;
        this._bulkActionsLimit = bulkActionsLimit;
        this._defaultSortingField = defaultSortingField;
        this._sortingDirection = sortingDirection;
        this._enableWfActions = enableWfActions;
        this._pageSize = pageSize;
        this._enableWorkflowBulkActions = enableWorkflowBulkActions;
        this._workflowBulkActionIds = workflowBulkActionIds;
        this._moneyColumnByCurrency = moneyColumnByCurrency;
        this._additionalFieldsToLoad = additionalFieldsToLoad;
        this._categoryFieldsToLoad = categoryFieldsToLoad;
    }
    Object.defineProperty(PortfolioConfigModel.prototype, "categoryPermissions", {
        get: function () {
            return this._categoryPermissions;
        },
        set: function (value) {
            this._categoryPermissions = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(PortfolioConfigModel.prototype, "categorySystemName", {
        get: function () {
            return this._categorySystemName;
        },
        set: function (value) {
            this._categorySystemName = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(PortfolioConfigModel.prototype, "columns", {
        get: function () {
            return this._columns;
        },
        set: function (value) {
            this._columns = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(PortfolioConfigModel.prototype, "deFormName", {
        get: function () {
            return this._deFormName;
        },
        set: function (value) {
            this._deFormName = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(PortfolioConfigModel.prototype, "formId", {
        get: function () {
            return this._formId;
        },
        set: function (value) {
            this._formId = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(PortfolioConfigModel.prototype, "defaultFilter", {
        get: function () {
            return this._defaultFilter;
        },
        set: function (value) {
            this._defaultFilter = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(PortfolioConfigModel.prototype, "itemsNumbersPerPage", {
        get: function () {
            return this._itemsNumbersPerPage;
        },
        set: function (value) {
            this._itemsNumbersPerPage = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(PortfolioConfigModel.prototype, "bulkActionsLimit", {
        get: function () {
            return this._bulkActionsLimit;
        },
        set: function (value) {
            this._bulkActionsLimit = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(PortfolioConfigModel.prototype, "defaultSortingField", {
        get: function () {
            return this._defaultSortingField;
        },
        set: function (value) {
            this._defaultSortingField = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(PortfolioConfigModel.prototype, "sortingDirection", {
        get: function () {
            return this._sortingDirection;
        },
        set: function (value) {
            this._sortingDirection = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(PortfolioConfigModel.prototype, "enableWfActions", {
        get: function () {
            return this._enableWfActions;
        },
        set: function (value) {
            this._enableWfActions = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(PortfolioConfigModel.prototype, "pageSize", {
        get: function () {
            return this._pageSize;
        },
        set: function (value) {
            this._pageSize = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(PortfolioConfigModel.prototype, "enableWorkflowBulkActions", {
        get: function () {
            return this._enableWorkflowBulkActions;
        },
        set: function (value) {
            this._enableWorkflowBulkActions = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(PortfolioConfigModel.prototype, "workflowBulkActionIds", {
        get: function () {
            return this._workflowBulkActionIds;
        },
        set: function (value) {
            this._workflowBulkActionIds = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(PortfolioConfigModel.prototype, "moneyColumnByCurrency", {
        get: function () {
            return this._moneyColumnByCurrency;
        },
        set: function (value) {
            this._moneyColumnByCurrency = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(PortfolioConfigModel.prototype, "additionalFieldsToLoad", {
        get: function () {
            return this._additionalFieldsToLoad;
        },
        set: function (value) {
            this._additionalFieldsToLoad = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(PortfolioConfigModel.prototype, "categoryFieldsToLoad", {
        get: function () {
            return this._categoryFieldsToLoad;
        },
        set: function (value) {
            this._categoryFieldsToLoad = value;
        },
        enumerable: true,
        configurable: true
    });
    return PortfolioConfigModel;
}());
exports.PortfolioConfigModel = PortfolioConfigModel;
//# sourceMappingURL=portfolio.configs.model.js.map